<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

  <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between">
          <p class="fw-bolder">
            ماتریس ارتباطات بیرونی / {{nameRoute}}</p>

            <button style="transform: translateX(1vw)" class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
        </div>
        <hr class="mt-3 mb-3">
        <table class="table table-striped" v-if="parseInt(type)===1" >
          <tbody>
          <tr>

            <th></th>
            <th v-for="item1 in beneficiary">{{item1.title}}</th>

          </tr>
          <tr v-for="item2 in processes">
            <td >{{item2.title}}</td>
            <td v-for="item1 in beneficiary">
              <span v-for="item3 in supplierInputs">
                <span v-if="item3.beneficiaries_self_id===item1.id && item3.category_id===item2.code">{{item3.title}}</span>
              </span>
            </td>
          </tr>



          </tbody>
        </table>
        <table class="table table-striped" v-if="parseInt(type)===2" >
          <tbody>
          <tr>

            <th></th>
            <th v-for="item1 in beneficiary">{{item1.title}}</th>

          </tr>
          <tr v-for="item2 in processes">
            <td >{{item2.title}}</td>
            <td v-for="item1 in beneficiary">
              <span v-for="item3 in supplierInputs">
                <span v-if="item3.beneficiaries_self_id===item1.id && item3.category_number===item2.code">{{item3.title}}</span>
              </span>
            </td>
          </tr>



          </tbody>
        </table>


        <table class="table table-striped" v-if="parseInt(type)===3 || parseInt(type)===4 " >
          <tbody>
          <tr>

            <th></th>
            <th v-for="item1 in beneficiary">{{item1.title}}</th>

          </tr>
          <tr v-for="item2 in processes">
            <td >{{item2.title}}</td>
            <td v-for="item1 in beneficiary">
              <span v-for="item3 in supplierInputs">

                <span v-if="item3.beneficiaries_self_id===item1.id && item3.processes_id===item2.id">{{item3.title}}</span>
              </span>
            </td>
          </tr>



          </tbody>
        </table>

        <table class="table table-striped" v-if=" parseInt(type)===7 || parseInt(type)===8 " >
          <tbody>
          <tr>
            <th></th>
            <th v-for="item1 in processes ">{{item1.title}}</th>
          </tr>
          <tr v-for="item2 in beneficiary">
            <td >{{item2.title}}</td>
            <td v-for="item1 in processes">
              <span v-for="item3 in supplierInputs">

                <span v-if="item3.beneficiaries_self_id===item2.id && item3.processes_id===item1.id">{{item3.title}}</span>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
        <table class="table table-striped" v-if="parseInt(type)===5" >
          <tbody>
          <tr>
            <th></th>
            <th v-for="item1 in processes ">{{item1.title}}</th>
          </tr>
          <tr v-for="item2 in beneficiary">
            <td >{{item2.title}}</td>
            <td v-for="item1 in processes">
              <span v-for="item3 in supplierInputs">

                <span v-if="item3.beneficiaries_self_id===item1.id && item3.category_id===item2.code">{{item3.title}}</span>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
        <table class="table table-striped" v-if="parseInt(type)===6" >
          <tbody>
          <tr>
            <th></th>
            <th v-for="item1 in processes ">{{item1.title}}</th>
          </tr>
          <tr v-for="item2 in beneficiary">
            <td >{{item2.title}}</td>
            <td v-for="item1 in processes">
              <span v-for="item3 in supplierInputs">

                <span v-if="item3.category_number===item1.code && item3.beneficiaries_self_id===item2.id">{{item3.title}}</span>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>



</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data(){
    return{
      showProcessFilter: false,
      select_inserter: false,
      inserterId: '',
      search_inserter: '',
      itemsOrgan: [],
      all_inserter: [],
      supplierInputs: [],
      processes: [],
      beneficiary: [],
      nameRoute: '',
      type: this.$route['params']['type'],
    }
  },
  methods:{
    routeExport(){
      console.log(this.type)
      if (parseInt(this.type) ===1){
        this.nameRoute = 'ارتباط ذی نفع - فرآیند در سطح طبقه'

      } if (parseInt(this.type) ===2) {
        this.nameRoute = 'ارتباط ذی نفع - فرآیند در سطح گروه'
      } if (parseInt(this.type) ===3) {
        this.nameRoute = 'ارتباط ذی نفع - فرآیند در سطح فرآیند'
      } if (parseInt(this.type) ===4) {
        this.nameRoute = 'ارتباط ذی نفع - فرآیند در سطح زیر فرآیند'
      } if (parseInt(this.type) ===5) {
        this.nameRoute = 'ارتباط  فرآیند-ذی نفع در سطح طبقه'
      } if (parseInt(this.type) ===6) {
        this.nameRoute = 'ارتباط  فرآیند-ذی نفع در سطح گروه'
      } if (parseInt(this.type) ===7) {
        this.nameRoute = 'ارتباط  فرآیند-ذی نفع در سطح فرآیند'
      } if (parseInt(this.type) ===8) {
        this.nameRoute = 'ارتباط  فرآیند-ذی نفع در سطح زیر فرآیند'
      }

    },
    all(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      if (parseInt(this.type) ===1){
        formdata.append('level','1')

      } if (parseInt(this.type) ===2) {
        formdata.append('level','2')
      } if (parseInt(this.type) ===3) {
        formdata.append('level','3')
      } if (parseInt(this.type) ===4) {
        formdata.append('level','4')
      } if (parseInt(this.type) ===5) {
        formdata.append('level','5')
      } if (parseInt(this.type) ===6) {
        formdata.append('level','6')
      } if (parseInt(this.type) ===7) {
        formdata.append('level','7')
      } if (parseInt(this.type) ===8) {
        formdata.append('level','8')
      }


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/MatrixConnections/export`, requestOptions)
          .then(response => response.json())
          .then(response => {

            if (response.supplierInputs){
              this.supplierInputs = [...response.supplierInputs]
            }
            if (response.processes){
              this.processes = [...response.processes]
            }
            if (response.beneficiary){
              this.beneficiary = [...response.beneficiary]
            }

            setTimeout(() => {
              const cells = document.querySelectorAll("span");
              cells.forEach((cell, index) => {
                const cellContent = cell.innerText.trim();
                if (cellContent === '') {
                  // Remove empty spans
                  cell.remove();
                }
                // Check if there is a next sibling span
                const hasNextSibling = cell.nextElementSibling && cell.nextElementSibling.tagName === "SPAN";
                if (hasNextSibling) {
                  // Add a slash as a separator between cell content and the next one
                  cell.innerHTML = cellContent + '/';
                }
              });
            }, 1000);

          })
          .catch();
    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.all()
    this.checkIsMother()
    this.routeExport()
  },

  computed:{
    filteredorganization() {
      return this.all_inserter.filter(item => {
        return (
            item['name'].includes(this.search_inserter) ||
            item['id'].toString().includes(this.search_inserter)
        );
      });
    },
  }
}
</script>
<style scoped>
td:empty::before {
  content: "--";
}

</style>